import $ from 'jquery'
import 'jquery-ui-dist/jquery-ui'
import { showErrorStrToast, showToast } from './toastActions'
import { useUIStateActions } from '../hooks/uiHooks'
import { isModalOpened } from '../utils/uiUtils'
import { ModalId } from '../components/modal/types'
import { useNavigate } from 'react-router-dom'
import { RoutePath } from '../../routes'

export const useUIActions = () => {
    const navigate = useNavigate()
    const { setOpenedModal } = useUIStateActions()

    const onSubmitDataType = (createMode: boolean, goBack = true, routePath?: RoutePath) => {
        showToast(createMode ? 'El nuevo registro fue guardado.' : 'El registro fue actualizado.')
        if (goBack) {
            navigate(-1)
        } else if (routePath) {
            navigate(routePath)
        }
    }

    const onRemoveDataType = () => {
        showErrorStrToast('El registro fue eliminado.')
    }

    const onArchiveDataType = () => {
        showErrorStrToast('El registro fue archivado.')
    }

    const toggleModal = (modalId: string) => {
        setOpenedModal(isModalOpened(modalId) ? undefined : modalId as ModalId)
        $(`#open-${modalId}`).trigger('click')
    }

    const openModal = (modalId: string) => {
        if (!isModalOpened(modalId)) {
            setOpenedModal(modalId as ModalId)
            $(`#open-${modalId}`).trigger('click')
        }
    }

    const closeModal = (modalId: string) => {
        if (isModalOpened(modalId)) {
            setOpenedModal(undefined)
            $(`#open-${modalId}`).trigger('click')
        }
    }

    const closeModalOverlay = () => {
        const overlay = $('.modal-backdrop.fade.show')
        if (overlay.length > 0) {
            overlay.remove()
        }
        // Bootstrap bloquea el scroll del body mientras hay un modal abierto; si el modal se desmonta sin cerrarse, el bloqueo queda
        if ($('.modal.show').length === 0) {
            $('body').removeClass('modal-open').css({ overflow: '', paddingRight: '' })
        }
    }

    return {
        onSubmitDataType,
        onRemoveDataType,
        onArchiveDataType,
        toggleModal,
        openModal,
        closeModal,
        closeModalOverlay
    }
}
